import { FaWhatsapp, FaInstagram, FaTiktok, FaThreads } from "react-icons/fa6";
import { MapPin, Clock, MessageCircle, ShieldCheck, RotateCcw } from "lucide-react";
import Seo from "@/components/Seo";
import { STORE, WA_DISPLAY, waLink } from "@/lib/constants";

export default function Kontak() {
  return (
    <div className="mx-auto max-w-5xl px-4 py-14 sm:px-6">
      <Seo title="Kontak" path="/kontak" description="Hubungi BigBerry Store via WhatsApp. Jam operasional 09.00-20.00 WIB. Lokasi di Kelapa Gading, Jakarta Utara." />

      <p className="text-sm font-medium uppercase tracking-widest text-berry">Kontak</p>
      <h1 className="mt-1 font-heading text-4xl font-800 tracking-tight text-white">Hubungi Kami</h1>
      <p className="mt-3 max-w-2xl text-gray-400">
        Ada pertanyaan seputar produk, harga, atau cicilan? Tim BigBerry siap membantu Anda.
      </p>

      <div className="mt-10 grid gap-4 md:grid-cols-2">
        <div className="rounded-2xl border border-white/5 bg-[#12141C] p-6">
          <div className="mb-3 inline-flex rounded-xl bg-whatsapp/15 p-3 text-whatsapp"><FaWhatsapp className="h-6 w-6" /></div>
          <h3 className="font-heading text-lg font-600 text-white">WhatsApp</h3>
          <p className="mt-1 text-sm text-gray-400">{WA_DISPLAY}</p>
          <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="kontak-whatsapp" className="mt-4 inline-flex items-center gap-2 rounded-full bg-whatsapp px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-whatsapp-dark">
            <FaWhatsapp className="h-4 w-4" /> Chat Sekarang
          </a>
        </div>

        <div className="rounded-2xl border border-white/5 bg-[#12141C] p-6">
          <div className="mb-3 inline-flex rounded-xl bg-berry/10 p-3 text-berry"><Clock className="h-6 w-6" /></div>
          <h3 className="font-heading text-lg font-600 text-white">Jam Operasional</h3>
          <p className="mt-1 text-sm text-gray-400">{STORE.hours}</p>
        </div>

        <div className="rounded-2xl border border-white/5 bg-[#12141C] p-6 md:col-span-2">
          <div className="mb-3 inline-flex rounded-xl bg-berry/10 p-3 text-berry"><MapPin className="h-6 w-6" /></div>
          <h3 className="font-heading text-lg font-600 text-white">Lokasi</h3>
          <p className="mt-1 text-sm text-gray-400">{STORE.address}</p>
        </div>

        <div className="rounded-2xl border border-white/5 bg-[#12141C] p-6 md:col-span-2">
          <div className="mb-3 inline-flex rounded-xl bg-berry/10 p-3 text-berry"><MessageCircle className="h-6 w-6" /></div>
          <h3 className="font-heading text-lg font-600 text-white">Media Sosial</h3>
          <div className="mt-4 flex flex-wrap gap-3">
            <a href={STORE.social.instagram} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full border border-white/10 px-4 py-2 text-sm text-gray-300 hover:border-berry hover:text-white">
              <FaInstagram className="h-4 w-4" /> @bigberrystore
            </a>
            <a href={STORE.social.threads} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full border border-white/10 px-4 py-2 text-sm text-gray-300 hover:border-berry hover:text-white">
              <FaThreads className="h-4 w-4" /> @bigberrystore
            </a>
            <a href={STORE.social.tiktok} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full border border-white/10 px-4 py-2 text-sm text-gray-300 hover:border-berry hover:text-white">
              <FaTiktok className="h-4 w-4" /> @bigberrystore
            </a>
          </div>
        </div>
      </div>

      {/* Garansi & Retur */}
      <div className="mt-12 grid gap-4 md:grid-cols-2">
        <div className="rounded-2xl border border-white/5 bg-[#12141C] p-6">
          <div className="mb-3 inline-flex items-center gap-2 text-white"><ShieldCheck className="h-5 w-5 text-electric" /> <h3 className="font-heading text-lg font-600">Kebijakan Garansi</h3></div>
          <p className="text-sm leading-relaxed text-gray-400">
            Seluruh produk bergaransi resmi Indonesia sesuai ketentuan masing-masing brand/distributor.
            Klaim garansi mengikuti prosedur resmi pabrikan. Simpan bukti pembelian & kartu garansi Anda.
          </p>
        </div>
        <div className="rounded-2xl border border-white/5 bg-[#12141C] p-6">
          <div className="mb-3 inline-flex items-center gap-2 text-white"><RotateCcw className="h-5 w-5 text-electric" /> <h3 className="font-heading text-lg font-600">Kebijakan Retur</h3></div>
          <p className="text-sm leading-relaxed text-gray-400">
            Unit dicek bersama saat serah terima. Retur/penukaran hanya berlaku untuk cacat produksi
            sesuai ketentuan garansi resmi dan wajib melapor maksimal 1x24 jam. Hubungi kami via WhatsApp.
          </p>
        </div>
      </div>
    </div>
  );
}
